import { render, staticRenderFns } from "./AuditWorkbench.vue?vue&type=template&id=86756fb2&scoped=true"
import script from "./AuditWorkbench.vue?vue&type=script&lang=js"
export * from "./AuditWorkbench.vue?vue&type=script&lang=js"
import style0 from "./AuditWorkbench.vue?vue&type=style&index=0&id=86756fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86756fb2",
  null
  
)

export default component.exports